import React from 'react';
import PropTypes from 'prop-types';

import FormGroupRowLargeSelect from "./FormGroupRowLargeSelect";

const FormGroupRowSender = ({senders, onChange, multi, wrapperStyle, ...props}) => {

    const options = senders.map(item => ({
        value: item.id,
        label: item.id + ': ' + item.name + ' (' + item.senderContractNumber + ')',
    }));

    return (
        <FormGroupRowLargeSelect
            {...props}
            onChange={onChange}
            options={options}
            multi={multi}
            addEmptyOption={!multi}
            wrapperStyle={wrapperStyle}
        />
    );
};

FormGroupRowSender.propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    value: PropTypes.any.isRequired,
    senders: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    wrapperStyle: PropTypes.object,
};

export default FormGroupRowSender;